import Column from "@/components/Ui/Column";
import Link from "next/link";
import type { ReactNode } from "react";

type Props = {
  code: number | string;
  customTitle?: string;
  customMessage?: string;
  customActions?: ReactNode;
};

const ERROR_MESSAGES: Record<number, { title: string; message: string }> = {
  400: {
    title: "Bad Request",
    message: "The request could not be understood",
  },
  401: {
    title: "Unauthorized",
    message: "You need to log in to view this page",
  },
  403: {
    title: "Forbidden",
    message: "You don't have permission to view this page",
  },
  404: {
    title: "Not Found",
    message: "Page not found",
  },
  500: {
    title: "Internal Server Error",
    message: "Something went wrong on our end",
  },
  502: {
    title: "Bad Gateway",
    message: "The server received an invalid response",
  },
  503: {
    title: "Service Unavailable",
    message: "The service is temporarily unavailable",
  },
};

const ErrorCode = ({
  code,
  customTitle,
  customMessage,
  customActions,
}: Props) => {
  const numericCode = typeof code === "string" ? Number(code) : code;
  const error = ERROR_MESSAGES[numericCode] || {
    title: "Error",
    message: "An unexpected error occurred",
  };

  return (
    <Column className="flex-1 gap-5 p-6">
      <h1 className="text-4xl font-bold">
        {customTitle || `${numericCode} - ${error.title}`}
      </h1>
      <p className="text-muted-foreground text-center">
        {customMessage || error.message}
      </p>
      {customActions ?? (
        <Link href="/" className="text-primary underline">
          Go home
        </Link>
      )}
    </Column>
  );
};

export default ErrorCode;
